export default {
	general: {
		save: 'Tallenna',
		cancel: 'Peruuta',
		yes: 'Kyllä',
		no: 'Ei',
		goBack: 'Palaa takaisin',
		changeCookieSettings: 'Muuta evästeasetuksiasi',
	},
	restrictedMode: {
		text: 'Jäsenlaskusi on maksamatta. Maksamalla jäsenlaskusi saat käyttöösi sovelluksen kaikki ominaisuudet.',
	},
	routes: {
		error404: {
			title: 'Sivua ei löytynyt',
		},
		membershipCard: {
			title: 'Kortti',
		},
		myAccount: {
			title: 'Omat tiedot',
			headline: 'Omat tiedot',
		},
		benefitContainer: {
			title: 'Edut',
			headline: 'Jäsenedut',
		},
		benefit: {
			title: 'Jäsenetu',
			headline: 'Jäsenetu',
		},
		eventContainer: {
			title: 'Tapahtumat',
			headline: 'Tapahtumat',
		},
		event: {
			title: 'Tapahtuma',
			headline: 'Tapahtuma',
		},
		newsContainer: {
			title: 'Uutiset',
			headline: 'Uutiset',
		},
		news: {
			title: 'Uutinen',
			headline: 'Uutinen',
		},
		pageContainer: {
			title: 'Materiaalit',
			headline: 'Materiaalit',
		},
		page: {
			title: 'Sivu',
			headline: 'Sivu',
		},
		invoiceContainer: {
			title: 'Laskut',
			headline: 'Laskut',
		},
		invoice: {
			title: 'Lasku',
			headline: 'Lasku',
		},
		settings: {
			title: 'Asetukset',
			headline: 'Asetukset',
		},
	},
	cookieTypes: {
		necessary: 'Välttämättömät',
		statistics: 'Tilastointi',
		marketing: 'Markkinointi',
	},
	validationErrors: {
		required: 'Tämä kenttä on pakollinen.',
		email: 'Tarkista sähköpostiosoitteen muotoilu.',
	},
}
